<script lang="ts">
  import chaptersStore, { type Cue } from '../../../stores/chapters.svelte'
  import videoStore from '../../../stores/video.svelte'
  import FullScreenPopup from '../FullScreenPopup.svelte'

  function onClose() {
    chaptersStore.state.chaptersScreenOpen = false
    if (chaptersStore.state.wasPlayingWhenOpened) {
      videoStore.state.videoController?.play()
    }
  }

  function onClick(cue: Cue) {
    videoStore.state.videoController?.setCurrentTime(cue.start)
    onClose()
  }
</script>

<FullScreenPopup onclose={() => onClose()}>
  <ul class="w-full text-sm text-center font-semibold">
    {#each chaptersStore.state.cues as cue}
      <li class="cursor-pointer my-2">
        <button
          onclick={() => onClick(cue)}
          onkeydown={(e) =>
            (e.key === 'Enter' || e.key === ' ') && onClick(cue)}
        >
          {cue.text}
        </button>
      </li>
    {/each}
  </ul>
</FullScreenPopup>
